import { JurisdictionDetailsPermittingType } from '@models/interfaces';
import { generateId } from './generate-permit-type-id';

export const getProcessedPermitTypes = (
  permitTypes?: JurisdictionDetailsPermittingType[] | undefined,
) =>
  (permitTypes || []).map((permitType: JurisdictionDetailsPermittingType) => ({
    ...permitType,
    generatedId: generateId(),
  }));
